<template>
  <div class="mobile_creativity">
    <img width="100%" :src="imgUrl" alt="" />
    <p style="font-size: 20px; margin-bottom: 10px;margin-top: 40px; font-weight: 700" class="mobile_creativity_p">
      Creative and Technical Support
    </p>
    <p style="font-size: 12px" class="mobile_creativity_p1">
       Our ecosystem partners with exceptional capabilities, from creative conception to complex full-scale execution, fully facilitate the efficient transformation of virtual production from inspiration to final creation. 
    </p>
    <button :style="{ backgroundColor: btnColor }" class="creativity_btn"
            @click="jumpTo('/en/CaseDemonstration#CallMe')">Contact us</button>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    imgUrl: {
      type: String,
      default: 'https://download.hecoos.com/enlightv/2025-17/a9139c333899bf3a42f9253481f5771b.png',
    },
    btnColor: {
      type: String,
      default: () => '#2a82e4',
    },
  },
  methods: {
    jumpTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/en_mobile/mobile_xty.scss";
</style>
